import { render, staticRenderFns } from "./companyPcCode.vue?vue&type=template&id=14f08193&scoped=true"
import script from "./companyPcCode.vue?vue&type=script&lang=js"
export * from "./companyPcCode.vue?vue&type=script&lang=js"
import style0 from "./companyPcCode.vue?vue&type=style&index=0&id=14f08193&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f08193",
  null
  
)

export default component.exports